// Preset furniture/appliance keys shared between owner forms (add/edit
// property, add/edit house) and the tenant-facing onboarding display —
// kept in one place so adding a new preset (or checking whether a
// furnishingItems key is a preset vs. an owner-typed custom item) only
// needs updating here.
export const FURNISHING_ITEM_KEYS = ["fan", "light", "ac", "fridge", "washingMachine", "sofa", "bed", "heater", "chimney"] as const;

export interface CustomItemDraft {
  name: string;
  qty: string;
}
